import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dispatch } from 'redux';
import * as Actions from '../actions/imstat';
import MessageDialog from '../components/MessageDialog';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ScenarioFactory, {
	IFetchTrainingProgressDataParam,
} from '../scenario/ImstatScenarioFactory';
import Config from '../site.config.json';
import { isMobile } from '../utils/MobileCheck';
import { Routes, Screens } from '../utils/Routes';
const ITEM_HEIGHT = 48;

const makeLink = (
	careerID: string,
	classID: string,
	outOfPeriodFlg: boolean
) => {
	const MyLink: React.FC<any> = props => {
		let pathname = Routes.getPath(Screens.ELEARNING);
		pathname = pathname.replace(/\/:career_id\//, `/${careerID}/`);
		pathname = pathname.replace(/\/:class_id$/, `/${classID}`);

		return (
			<Link
				to={{
					pathname,
					state: { caller: window.location.pathname, outOfPeriodFlg },
				}}
				{...props}
			/>
		);
	};
	return MyLink;
};

export enum ElearningTypes {
	ONGOING,
	RESULT,
}

const styles = (theme: Theme) =>
	createStyles({
		card: {
			height: '100%',
			width: 200,
		},
		content: {
			padding: theme.spacing(1),
		},
		eLearningTitle: {
			color: theme.palette.primary.main,
			cursor: 'pointer',
			fontSize: '108%',
			marginBottom: theme.spacing(1),
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			wordBreak: 'break-all',
		},
		link: {
			color: 'blue',
			cursor: 'pointer',
		},
		media: {
			height: 0,
			paddingTop: '56.25%',
		},
		root: {
			flexGrow: 1,
			padding: 24,
		},
	});

interface IState {
	errorStudyOrderdialogContent: string;
	errorStudyOrderdialogReplaceContent: string[];
	functionMenuAnchorEl?: HTMLElement;
	openErrorStudyOrderMessageDialog: boolean;
	openErrorJukouMessageDialog: boolean;
	openErrorJukouMobileMessageDialog: boolean;
	openErrorJukouStatusSinseiMessageDialog: boolean;
	openErrorExpiredMessageDialog: boolean;
	openErrorUdemyMessageDialog: boolean;
	width: number;
	openNoticeExpired: { term: string; target: string } | null;
}

/**
 * 実施状況カードコンポーネント
 */
class ELearningCard extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			errorStudyOrderdialogContent: '',
			errorStudyOrderdialogReplaceContent: [],
			openErrorExpiredMessageDialog: false,
			openErrorJukouMessageDialog: false,
			openErrorJukouMobileMessageDialog: false,
			openErrorJukouStatusSinseiMessageDialog: false,
			openErrorStudyOrderMessageDialog: false,
			openErrorUdemyMessageDialog: false,
			openNoticeExpired: null,
			width: 0,
		};
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
	}

	public render() {
		const { functionMenuAnchorEl } = this.state;

		if (this.props.IOnGoingData) {
			const { classes, IOnGoingData } = this.props;
			let period = IOnGoingData.jissiKikan;
			if (period && period.indexOf('～') !== -1) {
				period = period.replace(
					'～',
					i18n.t('～', {
						ns: 'force',
					})
				);
			}
			return (
				<>
					<Card className={classes.card}>
						<CardContent className={classes.content}>
							<Tooltip
								title={IOnGoingData.careerTitle}
								placement="top-start"
							>
								<Typography
									variant="h5"
									component="h2"
									className={classes.eLearningTitle}
									onClick={this.handleShowDetailDialog}
								>
									{IOnGoingData.careerTitle}
								</Typography>
							</Tooltip>
							<Typography component="p">
								{(() => {
									const status = i18n.t(IOnGoingData.status, {
										ns: 'force',
									});
									if (
										!isMobile() &&
										['0', '1', '2', '3', '4'].indexOf(
											IOnGoingData.aplType
										) !== -1
									) {
										return (
											<span>
												{i18n.t('ELearningCard_0001')}:
												<span
													className={
														this.props.classes.link
													}
													onClick={
														this
															.showApplicationStatus
													}
												>
													{status}
												</span>
											</span>
										);
									} else {
										return (
											<span>
												{i18n.t('ELearningCard_0001')}:{' '}
												{status}
											</span>
										);
									}
								})()}
							</Typography>
							<Typography component="p">
								{i18n.t('ELearningCard_0002')}: {period}
							</Typography>
							<Typography component="p">
								{i18n.t('ELearningCard_0003')}:{' '}
								{IOnGoingData.courseStartDate}
							</Typography>
							<Typography component="p">
								{i18n.t('ELearningCard_0004')}:{' '}
								{IOnGoingData.courseEndDate}
							</Typography>
							<Typography component="div">
								{i18n.t('ELearningCard_0005')}:
								{this.progress(
									IOnGoingData.progress,
									IOnGoingData.createProgressLinkFlg
								)}
							</Typography>
						</CardContent>
						<CardActions>
							{(() => {
								const {
									jukou,
									careerID,
									classID,
									enqueteDispFlg,
									taskReportOkFlg,
									status,
									outOfPeriodFlg,
									kadaiWithin,
									enqueteWithin,
									uncompletedCareers,
									unrepresentedCareerCnt,
									externalCourseType,
								} = IOnGoingData;

								let jukouButtonLabel: string = i18n.t(
									'ELearningCard_0006'
								);
								let canTraining: boolean = false;
								let cannotTrainingClickCb: () => void = this
									.errorMessageJukouDialogOpen;

								if (
									jukou.slice(0, 1) === '1' &&
									externalCourseType !== 1
								) {
									// jukouの先頭が1であればそのまま表示
									jukouButtonLabel = jukou.replace(/1,/, '');
									jukouButtonLabel = i18n.t(
										jukouButtonLabel,
										{ ns: 'force' }
									);
									if (
										outOfPeriodFlg &&
										kadaiWithin === 0 &&
										enqueteWithin === 0
									) {
										// アンケートも課題も期限切れ
										cannotTrainingClickCb = this
											.errorMessageExpiredDialogOpen;
									} else {
										// 期限内
										canTraining = true;
									}
								} else if (externalCourseType === 1) {
									// Udemyの場合は受講不可
									cannotTrainingClickCb = this
										.errorMessageUdemyDialogOpen;
								} else if (status === '受講申請中') {
									// 受講申請中の場合は受講不可
									cannotTrainingClickCb = this
										.errorMessageJukouStatusSinseiDialogOpen;
								} else if (
									status === '取消申請中' ||
									status === '実績申請中'
								) {
									// 取消申請中・実績申請中の場合は受講不可
									cannotTrainingClickCb = this
										.errorMessageJukouDialogOpen;
								} else if (
									isMobile() &&
									(!enqueteDispFlg && taskReportOkFlg)
								) {
									// 【モバイル用対処】
									// モバイル＆コンテンツなし＆課題のみは受講不可
									cannotTrainingClickCb = this
										.errorMessageJukouMobileDialogOpen;
								} else if (enqueteDispFlg || taskReportOkFlg) {
									// アンケート・課題があれば受講可
									jukouButtonLabel = i18n.t(
										'ELearningCard_0007'
									);
									canTraining = true;
								} else {
									// 上記以外の場合、受講不可
									cannotTrainingClickCb = this
										.errorMessageJukouDialogOpen;
								}

								if (canTraining) {
									return (
										<>
											<Button
												variant="contained"
												color="primary"
												size="small"
												onClick={this.handleTrainingClick(
													careerID,
													classID,
													outOfPeriodFlg,
													uncompletedCareers,
													unrepresentedCareerCnt
												)}
											>
												{jukouButtonLabel}
											</Button>
										</>
									);
								} else {
									return (
										<>
											<Button
												variant="contained"
												color="default"
												size="small"
												onClick={cannotTrainingClickCb}
											>
												{jukouButtonLabel}
											</Button>
										</>
									);
								}
							})()}
							{isMobile() &&
								(IOnGoingData.appChangeOkFlg ||
									IOnGoingData.appResultOkFlg ||
									IOnGoingData.lecCancelOkFlg ||
									IOnGoingData.appCancelOkFlg) && (
									<IconButton onClick={this.handleOpenMenu}>
										<MenuIcon />
									</IconButton>
								)}
							{!isMobile() && (
								<IconButton onClick={this.handleOpenMenu}>
									<MenuIcon />
								</IconButton>
							)}
							<Menu
								anchorEl={functionMenuAnchorEl}
								open={Boolean(functionMenuAnchorEl)}
								onClose={this.handleCloseMenu}
								anchorOrigin={{
									horizontal: 'center',
									vertical: 'bottom',
								}}
								transformOrigin={{
									horizontal: 'center',
									vertical: 'top',
								}}
								getContentAnchorEl={undefined}
								PaperProps={{
									style: {
										maxHeight: ITEM_HEIGHT * 4.5,
										width: 200,
									},
								}}
							>
								{!isMobile() && (
									<MenuItem onClick={this.showDetail}>
										{i18n.t('ELearningCard_0008')}
									</MenuItem>
								)}
								{IOnGoingData.appChangeOkFlg && (
									<MenuItem
										onClick={this.showChangeApplication}
									>
										{i18n.t('ELearningCard_0009')}
									</MenuItem>
								)}
								{IOnGoingData.appResultOkFlg && (
									<MenuItem
										onClick={this.showActResultApplication}
									>
										{i18n.t('ELearningCard_0010')}
									</MenuItem>
								)}
								{IOnGoingData.lecCancelOkFlg && (
									<MenuItem onClick={this.showStCancel}>
										{i18n.t('ELearningCard_0011')}
									</MenuItem>
								)}
								{IOnGoingData.appCancelOkFlg && (
									<MenuItem
										onClick={this.showCancelApplication}
									>
										{i18n.t('ELearningCard_0012')}
									</MenuItem>
								)}
								{!isMobile() && IOnGoingData.testFlg && (
									<MenuItem onClick={this.showHistory}>
										{i18n.t('ELearningCard_0013')}
									</MenuItem>
								)}
							</Menu>
						</CardActions>
					</Card>
					<MessageDialog
						open={
							this.state.openErrorJukouStatusSinseiMessageDialog
						}
						showCancelButton={false}
						title={i18n.t('ELearningCard_0014')}
						contents={[{ content: 'LMCM_E_00677' }]}
						onClose={this.errorMessageJukouStatusSinseiDialogClose}
						onClickOk={
							this.errorMessageJukouStatusSinseiDialogClose
						}
					/>
					<MessageDialog
						open={this.state.openErrorUdemyMessageDialog}
						showCancelButton={false}
						title={i18n.t('ELearningCard_0014')}
						contents={[{ content: 'LMCM_E_16211' }]}
						onClose={this.errorMessageUdemyDialogClose}
						onClickOk={this.errorMessageUdemyDialogClose}
					/>
					<MessageDialog
						open={this.state.openErrorJukouMessageDialog}
						showCancelButton={false}
						title={i18n.t('ELearningCard_0014')}
						contents={[{ content: 'LMCM_I_00634' }]}
						onClose={this.errorMessageJukouDialogClose}
						onClickOk={this.errorMessageJukouDialogClose}
					/>
					<MessageDialog
						open={this.state.openErrorJukouMobileMessageDialog}
						showCancelButton={false}
						title={i18n.t('ELearningCard_0014')}
						contents={[{ content: 'LMCM_E_00678' }]}
						onClose={this.errorMessageJukouMobileDialogClose}
						onClickOk={this.errorMessageJukouMobileDialogClose}
					/>
					<MessageDialog
						open={this.state.openErrorExpiredMessageDialog}
						showCancelButton={false}
						title={i18n.t('ELearningCard_0014')}
						contents={[{ content: 'LMCM_E_00693' }]}
						onClose={this.errorMessageExpiredDialogClose}
						onClickOk={this.errorMessageExpiredDialogClose}
					/>
					<MessageDialog
						open={this.state.openErrorStudyOrderMessageDialog}
						showCancelButton={false}
						title={i18n.t('ELearningCard_0014')}
						contents={[
							{
								content: this.state
									.errorStudyOrderdialogContent,
								replacements: this.state
									.errorStudyOrderdialogReplaceContent,
							},
						]}
						onClose={this.handleErrorMessageStudyOrderDialogClose}
						onClickOk={this.handleErrorMessageStudyOrderDialogClose}
					/>
					{this.state.openNoticeExpired && (
						<Dialog
							open={true}
							onClose={this.handleCloseNoticeExpired}
						>
							<DialogTitle>
								{i18n.t('ELearningCard_0015')}
							</DialogTitle>
							<DialogContent>
								<DialogContentText>
									{i18n.t('ELearningCard_0016', {
										target: this.state.openNoticeExpired
											.target,
										term: this.state.openNoticeExpired.term,
									})}
								</DialogContentText>
							</DialogContent>
							<DialogActions>
								<Button
									onClick={this.handleCloseNoticeExpired}
									color="primary"
								>
									{i18n.t('ELearningCard_0017')}
								</Button>
							</DialogActions>
						</Dialog>
					)}
				</>
			);
		} else if (this.props.IResultData) {
			const { classes, IResultData } = this.props;

			return (
				<>
					<Card className={classes.card}>
						<CardContent className={classes.content}>
							<Tooltip
								title={IResultData.careerTitle}
								placement="top-start"
							>
								<Typography
									variant="h5"
									component="h2"
									className={classes.eLearningTitle}
									onClick={this.handleShowDetailDialog}
								>
									{IResultData.careerTitle}
								</Typography>
							</Tooltip>
							<Typography component="p">
								{(() => {
									const status = i18n.t(IResultData.status, {
										ns: 'force',
									});
									if (
										!isMobile() &&
										['0', '1', '2', '3', '4'].indexOf(
											IResultData.aplType
										) !== -1
									) {
										return (
											<span>
												{i18n.t('ELearningCard_0001')}:
												<span
													className={
														this.props.classes.link
													}
													onClick={
														this
															.showApplicationStatus
													}
												>
													{status}
												</span>
											</span>
										);
									} else {
										return (
											<div>
												{i18n.t('ELearningCard_0001')}:{' '}
												{status}
											</div>
										);
									}
								})()}
							</Typography>
							<Typography component="p">
								{i18n.t('ELearningCard_0003')}:{' '}
								{IResultData.startDate}
							</Typography>
							<Typography component="p">
								{i18n.t('ELearningCard_0004')}:{' '}
								{IResultData.endDate}
							</Typography>
						</CardContent>
						<CardActions>
							{(() => {
								const {
									jukou,
									careerID,
									classID,
									enqueteDispFlg,
									taskReportOkFlg,
									outOfPeriodFlg,
									kadaiWithin,
									enqueteWithin,
									externalCourseType,
								} = IResultData;
								let jukouButtonLabel: string = '';
								if (
									jukou.slice(0, 1) === '1' &&
									externalCourseType !== 1
								) {
									jukouButtonLabel = jukou.replace(/1,/, '');
									jukouButtonLabel = i18n.t(
										jukouButtonLabel,
										{ ns: 'force' }
									);
									if (
										outOfPeriodFlg &&
										kadaiWithin === 0 &&
										enqueteWithin === 0
									) {
										// アンケートも課題も期限切れ
										return (
											<Button
												variant="contained"
												color="default"
												size="small"
												onClick={
													this
														.errorMessageExpiredDialogOpen
												}
											>
												{jukouButtonLabel}
											</Button>
										);
									}
								} else if (
									isMobile() &&
									(!enqueteDispFlg &&
										taskReportOkFlg &&
										externalCourseType !== 1)
								) {
									// モバイル＆コンテンツなし＆課題のみは受講不可
									jukouButtonLabel = i18n.t(
										'ELearningCard_0006'
									);
									return (
										<>
											<Button
												variant="contained"
												color="default"
												size="small"
												onClick={
													this
														.errorMessageJukouMobileDialogOpen
												}
											>
												{jukouButtonLabel}
											</Button>
										</>
									);
								} else if (externalCourseType === 1) {
									jukouButtonLabel = i18n.t(
										'ELearningCard_0006'
									);
									return (
										<>
											<Button
												variant="contained"
												color="default"
												size="small"
												onClick={
													this
														.errorMessageUdemyDialogOpen
												}
											>
												{jukouButtonLabel}
											</Button>
										</>
									);
								} else if (enqueteDispFlg || taskReportOkFlg) {
									jukouButtonLabel = i18n.t(
										'ELearningCard_0007'
									);
								} else {
									jukouButtonLabel = i18n.t(
										'ELearningCard_0006'
									);
									return (
										<>
											<Button
												variant="contained"
												color="default"
												size="small"
												onClick={
													this
														.errorMessageJukouDialogOpen
												}
											>
												{jukouButtonLabel}
											</Button>
										</>
									);
								}
								return (
									<>
										<Button
											variant="contained"
											color="primary"
											size="small"
											component={makeLink(
												careerID,
												classID,
												outOfPeriodFlg
											)}
										>
											{jukouButtonLabel}
										</Button>
									</>
								);
							})()}
							{!isMobile() && (
								<>
									<IconButton onClick={this.handleOpenMenu}>
										<MenuIcon />
									</IconButton>
									<Menu
										anchorEl={functionMenuAnchorEl}
										open={Boolean(functionMenuAnchorEl)}
										onClose={this.handleCloseMenu}
										anchorOrigin={{
											horizontal: 'center',
											vertical: 'bottom',
										}}
										transformOrigin={{
											horizontal: 'center',
											vertical: 'top',
										}}
										getContentAnchorEl={undefined}
										PaperProps={{
											style: {
												maxHeight: ITEM_HEIGHT * 4.5,
												width: 200,
											},
										}}
									>
										<MenuItem onClick={this.showDetail}>
											{i18n.t('ELearningCard_0008')}
										</MenuItem>
										{IResultData.referenceOkFlg && (
											<MenuItem
												onClick={
													this.showActResultReference
												}
											>
												{i18n.t('ELearningCard_0018')}
											</MenuItem>
										)}
										{IResultData.certificateDispFlg && (
											<MenuItem
												onClick={
													this.showComplCertificate
												}
											>
												{i18n.t('ELearningCard_0019')}
											</MenuItem>
										)}
										{IResultData.retakeOkFlg && (
											<MenuItem onClick={this.showApply}>
												{i18n.t('ELearningCard_0020')}
											</MenuItem>
										)}
										{IResultData.testFlg && (
											<MenuItem
												onClick={this.showHistory}
											>
												{i18n.t('ELearningCard_0013')}
											</MenuItem>
										)}
									</Menu>
								</>
							)}
						</CardActions>
					</Card>
					<MessageDialog
						open={this.state.openErrorJukouMessageDialog}
						showCancelButton={false}
						title={i18n.t('ELearningCard_0014')}
						contents={[{ content: 'LMCM_I_00634' }]}
						onClose={this.errorMessageJukouDialogClose}
						onClickOk={this.errorMessageJukouDialogClose}
					/>
					<MessageDialog
						open={this.state.openErrorJukouMobileMessageDialog}
						showCancelButton={false}
						title={i18n.t('ELearningCard_0014')}
						contents={[{ content: 'LMCM_E_00678' }]}
						onClose={this.errorMessageJukouMobileDialogClose}
						onClickOk={this.errorMessageJukouMobileDialogClose}
					/>
					<MessageDialog
						open={this.state.openErrorUdemyMessageDialog}
						showCancelButton={false}
						title={i18n.t('ELearningCard_0014')}
						contents={[{ content: 'LMCM_E_16211' }]}
						onClose={this.errorMessageUdemyDialogClose}
						onClickOk={this.errorMessageUdemyDialogClose}
					/>
					<MessageDialog
						open={this.state.openErrorExpiredMessageDialog}
						showCancelButton={false}
						title={i18n.t('ELearningCard_0014')}
						contents={[{ content: 'LMCM_E_00693' }]}
						onClose={this.errorMessageExpiredDialogClose}
						onClickOk={this.errorMessageExpiredDialogClose}
					/>
					{this.state.openNoticeExpired && (
						<Dialog
							open={true}
							onClose={this.handleCloseNoticeExpired}
						>
							<DialogTitle>
								{i18n.t('ELearningCard_0015')}
							</DialogTitle>
							<DialogContent>
								<DialogContentText>
									{i18n.t('ELearningCard_0016', {
										target: this.state.openNoticeExpired
											.target,
										term: this.state.openNoticeExpired.term,
									})}
								</DialogContentText>
							</DialogContent>
							<DialogActions>
								<Button
									onClick={this.handleCloseNoticeExpired}
									color="primary"
								>
									{i18n.t('ELearningCard_0017')}
								</Button>
							</DialogActions>
						</Dialog>
					)}
				</>
			);
		}
		return;
	}

	protected handleShowDetailDialog = (e: React.MouseEvent<HTMLElement>) => {
		let dataCareerID: string = '';
		if (this.props.IOnGoingData) {
			dataCareerID = this.props.IOnGoingData.careerID;
		} else if (this.props.IResultData) {
			dataCareerID = this.props.IResultData.careerID;
		}
		const careerDetailDialog: Actions.ICareerDetailDialog = {
			apllType: '',
			careerID: dataCareerID,
			classID: '',
			curriculumFlg: '0',
			setApplicationStatusDialog: false,
			setOpenCareerDetailDialog: true,
			setOpenCurriculumDetailDialog: false,
		};
		this.props.setCareerDetailDialog(careerDetailDialog);
	};

	protected handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({ functionMenuAnchorEl: event.currentTarget });
	};

	/**
	 * メニュークローズハンドラ
	 */
	protected handleCloseMenu = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 受講ボタンエラーメッセージクローズ
	 */
	protected errorMessageJukouDialogClose = () => {
		this.setState({ openErrorJukouMessageDialog: false });
	};

	/**
	 * Udemyの閉じるボタンエラーメッセージ
	 */
	protected errorMessageUdemyDialogClose = () => {
		this.setState({ openErrorUdemyMessageDialog: false });
	};

	/**
	 * 受講ボタンエラーメッセージオープン
	 */
	protected errorMessageJukouDialogOpen = () => {
		this.setState({ openErrorJukouMessageDialog: true });
	};

	/**
	 * モバイル時受講ボタンエラーメッセージクローズ
	 */
	protected errorMessageJukouMobileDialogClose = () => {
		this.setState({ openErrorJukouMobileMessageDialog: false });
	};

	/**
	 * モバイル時受講ボタンエラーメッセージオープン
	 */
	protected errorMessageJukouMobileDialogOpen = () => {
		this.setState({ openErrorJukouMobileMessageDialog: true });
	};

	/**
	 * 受講申請中受講ボタンエラーメッセージクローズ
	 */
	protected errorMessageJukouStatusSinseiDialogClose = () => {
		this.setState({ openErrorJukouStatusSinseiMessageDialog: false });
	};

	/**
	 * 受講申請中受講ボタンエラーメッセージオープン
	 */
	protected errorMessageJukouStatusSinseiDialogOpen = () => {
		this.setState({ openErrorJukouStatusSinseiMessageDialog: true });
	};

	/**
	 * Udemyの開くエラーメッセージ
	 */
	protected errorMessageUdemyDialogOpen = () => {
		this.setState({ openErrorUdemyMessageDialog: true });
	};

	/**
	 * 受講ボタン期間外エラーメッセージクローズ
	 */
	protected errorMessageExpiredDialogClose = () => {
		this.setState({ openErrorExpiredMessageDialog: false });
	};

	/**
	 * 受講ボタン期間外エラーメッセージオープン
	 */
	protected errorMessageExpiredDialogOpen = () => {
		this.setState({ openErrorExpiredMessageDialog: true });
	};

	/**
	 * 受講ボタン処理
	 * @param e イベントオブジェクト
	 */
	protected handleTrainingClick = (
		careerID: string,
		classID: string,
		outOfPeriodFlg: boolean,
		uncompletedCareers: string,
		unrepresentedCareerCnt: string
	) => (e: React.MouseEvent<HTMLElement>) => {
		if (uncompletedCareers !== null && uncompletedCareers !== '') {
			this.handleErrorMessageStudyOrderDialogOpen();
			if (unrepresentedCareerCnt !== '0') {
				this.setState({ errorStudyOrderdialogContent: 'LMCM_E_15513' });
				this.setState({
					errorStudyOrderdialogReplaceContent: [
						uncompletedCareers,
						unrepresentedCareerCnt,
					],
				});
			} else {
				this.setState({ errorStudyOrderdialogContent: 'LMCM_E_15512' });
				this.setState({
					errorStudyOrderdialogReplaceContent: [uncompletedCareers],
				});
			}
		} else {
			let pathname = Routes.getPath(Screens.ELEARNING);
			pathname = pathname.replace(/\/:career_id\//, `/${careerID}/`);
			pathname = pathname.replace(/\/:class_id$/, `/${classID}`);
			this.props.pushHistoryState(pathname, {
				caller: window.location.pathname,
				outOfPeriodFlg,
			});
		}
	};

	/**
	 * 受講ボタンエラーメッセージクローズ
	 */
	protected handleErrorMessageStudyOrderDialogClose = () => {
		this.setState({ openErrorStudyOrderMessageDialog: false });
	};

	/**
	 * 受講ボタンエラーメッセージオープン
	 */
	protected handleErrorMessageStudyOrderDialogOpen = () => {
		this.setState({ openErrorStudyOrderMessageDialog: true });
	};

	/**
	 * 詳細画面表示
	 * @param e イベントオブジェクト
	 */
	protected showDetail = (e: React.MouseEvent<HTMLElement>) => {
		// IOnGoingとIResultどちらでも呼ばれる
		let careerID: string = '';
		if (this.props.IOnGoingData) {
			careerID = this.props.IOnGoingData.careerID;
		} else if (this.props.IResultData) {
			careerID = this.props.IResultData.careerID;
		}
		let to = Routes.getPath(Screens.PERSONAL_CAREER_DETAIL);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		this.props.pushHistory(to);

		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 申請変更画面表示
	 * @param e イベントオブジェクト
	 */
	protected showChangeApplication = (e: React.MouseEvent<HTMLElement>) => {
		// IOnGoingのみ呼ばれる
		if (this.props.IOnGoingData) {
			const cardData: Actions.IOnGoingELearning = this.props.IOnGoingData;
			const { careerID, classID } = cardData;
			let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CHANGE);
			to = to.replace(/\/:career_id/, `/${careerID}`);
			to = to.replace(/\/:class_id/, `/${classID}`);
			this.props.pushHistoryState(to, {
				caller: window.location.pathname,
			});
		}
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 実績申請画面表示
	 * @param e イベントオブジェクト
	 */
	protected showActResultApplication = (e: React.MouseEvent<HTMLElement>) => {
		if (this.props.IOnGoingData) {
			const cardData: Actions.IOnGoingELearning = this.props.IOnGoingData;
			const { careerID, classID } = cardData;
			let to = Routes.getPath(Screens.PERSONAL_ACT_RESULT_APPLICATION);
			to = to.replace(/\/:career_id/, `/${careerID}`);
			to = to.replace(/\/:class_id/, `/${classID}`);
			to = to.replace(/\/:nittei_only_flg/, `/0`);
			this.props.pushHistoryState(to, {
				caller: window.location.pathname,
			});
		}
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 実績参照画面表示
	 * @param e イベントオブジェクト
	 */
	protected showActResultReference = (e: React.MouseEvent<HTMLElement>) => {
		if (this.props.IResultData) {
			const cardData: Actions.IResultELearning = this.props.IResultData;
			const {
				careerID,
				classID,
				seq,
				imstatListStatusId,
				reasonCode,
			} = cardData;
			let to = Routes.getPath(Screens.PERSONAL_ACT_RESULT_REFERENCE);
			to = to.replace(/\/:career_id/, `/${careerID}`);
			to = to.replace(/\/:class_id/, `/${classID}`);
			to = to.replace(/\/:seq/, `/${seq}`);
			const state = {
				careerID,
				classID,
				imstatListStatusId,
				reasonCode,
				seq,
			};
			this.props.pushHistoryState(to, state);
		}
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 受講取消画面表示
	 * @param e イベントオブジェクト
	 */
	protected showStCancel = (e: React.MouseEvent<HTMLElement>) => {
		if (this.props.IOnGoingData) {
			const cardData: Actions.IOnGoingELearning = this.props.IOnGoingData;
			const { careerID, classID } = cardData;
			let to = Routes.getPath(Screens.PERSONAL_LECTURE_CANCEL);
			to = to.replace(/\/:career_id/, `/${careerID}`);
			to = to.replace(/\/:class_id/, `/${classID}`);
			to = to.replace(/\/:curriculum_flg/, `/0`);
			this.props.pushHistoryState(to, {
				caller: window.location.pathname,
			});
		}
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 申請取消画面表示
	 * @param e イベントオブジェクト
	 */
	protected showCancelApplication = (e: React.MouseEvent<HTMLElement>) => {
		// IOnGoingのみ呼ばれる
		if (this.props.IOnGoingData) {
			const cardData: Actions.IOnGoingELearning = this.props.IOnGoingData;
			const { aplType, careerID, classID } = cardData;
			let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CANCEL);
			to = to.replace(/\/:career_id/, `/${careerID}`);
			to = to.replace(/\/:class_id/, `/${classID}`);
			to = to.replace(/\/:apl_type/, `/${aplType}`);
			this.props.pushHistoryState(to, {
				caller: window.location.pathname,
			});
		}
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 進捗状況画面表示
	 * @param e イベントオブジェクト
	 */
	protected showTrainingProgress = (e: React.MouseEvent<HTMLElement>) => {
		let cardData: any;
		if (this.props.IOnGoingData) {
			cardData = this.props.IOnGoingData;
		}
		const { token, userAttr } = this.props;
		const { careerID, classID } = cardData;
		this.props.fetchTrainingProgressData(token, {
			careerID,
			classID,
			userAttr,
		});
	};

	/**
	 * 再申請画面表示
	 * @param e イベントオブジェクト
	 */
	protected showApply = (e: React.MouseEvent<HTMLElement>) => {
		if (this.props.IResultData) {
			const cardData: Actions.IELearning = this.props.IResultData;
			const { careerID } = cardData;
			const to = Routes.getPath(Screens.PERSONAL_LECTURE_APPLICATION);
			const state = {
				caller: window.location.pathname,
				careerType: '0',
				targetCareerId: careerID,
			};
			this.props.pushHistoryState(to, state);
		}
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 修了証明書表示
	 * @param e イベントオブジェクト
	 */
	protected showComplCertificate = (e: React.MouseEvent<HTMLElement>) => {
		if (this.props.IResultData) {
			const cardData: Actions.IResultELearning = this.props.IResultData;
			const { careerID } = cardData;
			const { userAttr } = this.props;

			let url =
				Config.tsqPath + '/tsq/pkg/action/per/certificate.action?';
			url = url + 'userId=' + userAttr.userId;
			url = url + '&locale=' + userAttr.locale;
			url = url + '&lang=' + userAttr.lang;
			url = url + '&careerID=' + careerID;
			url = url + '&accessType=10';
			window.open(url, '_blank');
		}
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * テストアンケート履歴表示
	 * @param e イベントオブジェクト
	 */
	protected showHistory = (event: React.MouseEvent<HTMLElement>) => {
		let cardData: any;
		if (this.props.IOnGoingData) {
			cardData = this.props.IOnGoingData;
		} else if (this.props.IResultData) {
			cardData = this.props.IResultData;
		}
		const { careerID, classID } = cardData;
		let to = Routes.getPath(Screens.PERSONAL_TEST_QUESTIONNAIRE_HISTORY);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		this.props.pushHistory(to);
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 申請内容画面表示
	 * @param e イベントオブジェクト
	 */
	protected showApplicationStatus = (e: React.MouseEvent<HTMLElement>) => {
		let cardData: any;
		if (this.props.IOnGoingData) {
			cardData = this.props.IOnGoingData;
		} else if (this.props.IResultData) {
			cardData = this.props.IResultData;
		}
		const { careerID, classID, aplType } = cardData;
		const careerDetailDialog: Actions.ICareerDetailDialog = {
			apllType: aplType,
			careerID,
			classID,
			curriculumFlg: '0',
			setApplicationStatusDialog: true,
			setOpenCareerDetailDialog: false,
			setOpenCurriculumDetailDialog: false,
		};
		this.props.setCareerDetailDialog(careerDetailDialog);
	};

	/**
	 * 進捗率の表示
	 * @param data propsのdata
	 */
	protected progress = (progress: any, createProgressLinkFlg: boolean) => {
		if (!progress) {
			return;
		}
		const progressBar: number = progress.slice(0, -1);
		if (createProgressLinkFlg) {
			return (
				<div
					style={{
						backgroundColor: '#dadada',
						borderRadius: '2px',
						cursor: 'pointer',
						display: 'inline-block',
						height: 20,
						width: '100%',
					}}
					onClick={this.showTrainingProgress}
				>
					<div
						style={{
							backgroundColor:
								progressBar > 66
									? '#85cc00'
									: progressBar > 33
									? '#ffbf00'
									: '#ff2e00',
							borderRadius: '2px',
							display: 'inline-block',
							height: '100%',
							transition: 'all .2s ease-out',
							width: `${progressBar}%`,
						}}
					>
						{progress}
					</div>
				</div>
			);
		} else {
			return <div style={{ height: 20 }}>---</div>;
		}
	};

	/**
	 * ウィンドウサイズ更新
	 */
	protected updateWindowDimensions = () => {
		this.setState({ width: window.innerWidth });
	};

	/**
	 * 期間外メッセージクローズハンドラ
	 */
	protected handleCloseNoticeExpired = () => {
		this.setState({ openNoticeExpired: null });
	};
}

const mapStateToProps = (state: IRootState) => ({
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchTrainingProgressData: (
		token: string,
		arg: IFetchTrainingProgressDataParam
	) => {
		const s = ScenarioFactory.createFetchTrainingProgressData(
			dispatch,
			token
		);
		s.run(arg);
	},
	pushHistory: (path: string) => dispatch(push(path)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),

	setCareerDetailDialog: (CareerDetailDialog: Actions.ICareerDetailDialog) =>
		dispatch(Actions.setCareerDetailDialog({ CareerDetailDialog })),
});

export interface IELearningCardProps {
	IOnGoingData?: Actions.IOnGoingELearning;
	IResultData?: Actions.IResultELearning;
	type: ElearningTypes;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IELearningCardProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ELearningCard);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/components/ELearningCard.tsx